import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import de from 'date-fns/locale/de'
registerLocale('de', de)

interface DatePickerProps {
  date?: string | Date
  onChange: (date) => void
  placeholder?: string
  minDate?: Date
  maxDate?: Date
  filter?: (Date) => boolean
  valid?: boolean
}

const Calendar = (props: DatePickerProps) => {
  const { date, onChange, placeholder, minDate, maxDate, filter, valid } = props

  return (
    <Wrapper valid={valid}>
      <CustomDatePicker
        onChange={onChange}
        selected={date}
        placeholderText={placeholder || 'Datum auswählen'}
        dateFormat='dd. MMMM yyyy'
        minDate={minDate}
        maxDate={maxDate}
        locale='de'
        filterDate={filter}
        calendarClassName='customCalendar'
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  min-width: 150px;
  overflow: hidden;
  border-radius: 0;
  border-bottom: 2px solid;
  line-height: 1.48;

  border-color: ${(props) => (props.valid ? '#a7c9cd' : '#974353')};

  .react-datepicker-wrapper {
    width: 100%;
    padding: 15px 0;
    background-color: #d5e4e6;
  }

  .customCalendar {
    font-size: 15px;
    border-radius: 0;
    * {
    }
    .react-datepicker__day {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      padding: 2px;
      border-radius: 0;
    }
    .react-datepicker__day-names {
      display: flex;
      justify-content: space-evenly;
    }
    .react-datepicker__day--selected,
    .react-datepicker__day--keyboard-selected {
      background: #a7c9cd;
    }
    .react-datepicker__current-month {
      margin-bottom: 7.5px;
      font-size: 15px;
    }
  }
`
Wrapper.defaultProps = {
  valid: true
}

const CustomDatePicker = styled(DatePicker)`
  display: inline;
  width: 100%;
  padding: 0 30px;
  border: none;
  background-color: #d5e4e6;
  font-size: 15px;
  ::placeholder {
    color: #9b9b9b;
  }
  ${media.tablet`
    text-align: left;
    padding-left: 30px;
  `}
`

export default Calendar



// WEBPACK FOOTER //
// ./src/components/atoms/input/Calendar.tsx